import { Controller } from 'stimulus'
import StimulusReflex from 'stimulus_reflex'
import Chart from 'chart.js/auto';
import consumer from '../channels/consumer';
/* This is your ApplicationController.
 * All StimulusReflex controllers should inherit from this class.
 *
 * Example:
 *
 *   import ApplicationController from './application_controller'
 *
 *   export default class extends ApplicationController { ... }
 *
 * Learn more at: https://docs.stimulusreflex.com
 */



export default class extends Controller {

  connect () {

    this.initializeNotyf();
    StimulusReflex.register(this);


  }

  // Check if ActionCable WebSocket connection is open
  isActionCableConnectionOpen() {
    return consumer.connection && consumer.connection.isOpen();
  }




  /* Application-wide lifecycle methods
   *
   * Use these methods to handle lifecycle concerns for the entire application.
   * Using the lifecycle is optional, so feel free to delete these stubs if you don't need them.
   *
   * Arguments:
   *
   *   element - the element that triggered the reflex
   *             may be different than the Stimulus controller's this.element
   *
   *   reflex - the name of the reflex e.g. "Example#demo"
   *
   *   error/noop - the error message (for reflexError), otherwise null
   *
   *   reflexId - a UUID4 or developer-provided unique identifier for each Reflex
   */

  beforeReflex (element, reflex, noop, reflexId) {
    // replace any icons on the buttons with a spinner
    // and disable the button
      //console.log(element)
      const icon = element.querySelector('i');
      const is_button = element.classList.contains('btn');
      const no_wait = element.classList.contains('nowait');
      
      if (icon && is_button && !no_wait) {
        //element.setAttribute("disabled", "disabled");
        icon.setAttribute("class", "bi");
        icon.classList.add('busy');
        icon.classList.add('d-inline-block')
        icon.classList.add('bi-arrow-repeat');
      }
      
  }

  reflexSuccess (element, reflex, noop, reflexId) {
    // show success message
    if (reflex.includes("LiveCall#muteXXXX")) {
      console.log("reflexSuccess", element, reflex, noop, reflexId)
      element.classList.remove('btn-white-outline');
      element.classList.add('btn-white');
      const icon = element.querySelector('i');
      if (icon) {
        icon.setAttribute("class", "bi bi-mic-mute-fill");
      }
      
      
    }
  }

  reflexError (element, reflex, error, reflexId) {
    // show error message
    console.error(error)

  }

  reflexHalted (element, reflex, error, reflexId) {
    // handle aborted Reflex action
    console.error(error)
    console.error("Halted ")
  }

  afterReflex (element, reflex, noop, reflexId) {
    // document.body.classList.remove('wait')

    // Check if the Notyf container exists, reinit if not
    // this is to prevent stimulus reflex from removing the notyf container
    // on full page reflexes


    
  }

  finalizeReflex (element, reflex, noop, reflexId) {
    // all operations have completed, animation etc is now safe

    
  }

  initializeNotyf() {
    if (document.querySelector('.notyf')) {
      return;
    }
    this.unloadNotyf();
    window.notyf = new Notyf({
      duration: 5000,
      position: { x: 'right', y: 'top' },
        types: [
            {
                type: 'alert',
                className: 'w-full',
                ripple: false,
                background: 'red',
                dismissible: false,
                duration: 0,
                icon: {
                    className: 'bi bi-exclamation-triangle-fill',
                    tagName: 'i',
                    color: 'white'
                },
                position: {
                    x: 'center',
                    y: 'top',
                },
            },
            {
                type: 'info',
                className: 'w-full',
                ripple: false,
                background: '#6B9CD6',
                duration: 10000,
                icon: {
                    className: 'bi bi-info-circle-fill',
                    tagName: 'i',
                    color: 'white'
                },
                position: {
                    x: 'center',
                    y: 'top',
                },
            }
        ]
    });
    // Move Notyf container into our wrapper
    const notyfContainer = document.querySelector('#permanent-container')
    const notyfDiv = document.querySelector('.notyf');
    if (notyfDiv && notyfContainer) {
      notyfContainer.appendChild(notyfDiv);
    }
  }

  unloadNotyf() {
    if (window.notyf) {
      // Remove all existing notifications
      const notifications = document.querySelectorAll('.notyf__toast');
      notifications.forEach(notification => {
        window.notyf.dismiss(notification);
      });

      // Remove Notyf's container if it exists
      const notyfContainer = document.querySelector('.notyf');
      if (notyfContainer) {
        notyfContainer.remove();
      }

      // Delete the Notyf instance
      delete window.notyf;
    }
  }

}
